var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcRestart = function SvgIcRestart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.83 3.36a12.67 12.67 0 0 0-7.754 2.034l-.452.31a12.7 12.7 0 0 0-3.093 3.17L2.095 6.891l1.287 8.44 7.951-3.106-3.484-2.013a10 10 0 0 1 2.328-2.341l.357-.244a10 10 0 0 1 6.121-1.607l.432.038a10 10 0 0 1 5.75 2.643l.31.302a10 10 0 0 1 2.768 5.692l.049.43c.176 2.009-.26 4.025-1.25 5.782l-.22.374a10 10 0 0 1-11.607 4.221l-.408-.143a10 10 0 0 1-5.138-4.36l-2.31 1.334a12.67 12.67 0 0 0 6.508 5.52l.518.183a12.67 12.67 0 0 0 14.7-5.348l.28-.471a12.67 12.67 0 0 0 1.583-7.326l-.06-.545a12.67 12.67 0 0 0-3.508-7.209l-.392-.382a12.67 12.67 0 0 0-7.284-3.348z"
  })));
};
export default SvgIcRestart;